import { render } from "./details.vue?vue&type=template&id=cfd19e76&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=cfd19e76&lang=scss&scoped=true"

import exportComponent from "/root/workspace/A01_brandsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd19e76"]])

export default __exports__